@if (canAccessExternalData) {
  <p-selectButton
    class="ml-auto"
    [ngModel]="activeWidgetConfig.context"
    [allowEmpty]="false"
    (onChange)="setContext($event.value)"
    [options]="contextOptions"
    optionLabel="label"
    optionValue="key">
    <ng-template let-item pTemplate>
      <strong class="text-sm" [pTooltip]="item.tooltip">{{
        item.label
      }}</strong>
    </ng-template>
  </p-selectButton>
}
